export default __webpack_public_path__ + "static/media/icon-10.6e45b839.png";